/**
 * @description parse json object without throwing error. In case invalid JSON String returns null
 * @param {String} str JSON string
 * @returns {(Object|Null)} Parsed JSON object or null in case of the exception during parsing
 */
const parseJson = (str)  => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
};

export const parseJSON = parseJson;

